import React from 'react'
import { Container, Icon, Heading, Markdown } from '@scentregroup/ui'

import HttpStatusCode from '../../../server/lib/http-codes'
import errorMessages from './static-content'
import style from './index.module.scss'

interface IErrorProps {
  errorMessage?: string
  statusCode?: HttpStatusCode
}

interface IErrorLikeContentProps {
  title: string
  body: string
}

export const ErrorLikeContent: React.FC<
  React.PropsWithChildren<IErrorLikeContentProps>
> = ({ children, title, body }) => (
  <Container type="small" className={style.error}>
    <Icon type="alert" size="large" className={style.icon} />
    <Heading type="medium">{title}</Heading>
    <Markdown content={body} />
    {children}
  </Container>
)

const ErrorFeature: React.FunctionComponent<
  React.PropsWithChildren<IErrorProps>
> = ({ statusCode, errorMessage }) => {
  const content =
    (statusCode && errorMessages[statusCode]) || errorMessages.default
  const INDENT = 4

  const devMessage = `
  \`\`\`
  ${JSON.stringify(errorMessage, null, INDENT)}
  \`\`\`
  `

  return (
    <ErrorLikeContent title={content.title} body={content.body}>
      {__DEV__ && errorMessage && <Markdown content={devMessage} />}
    </ErrorLikeContent>
  )
}

export default ErrorFeature
